// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"spinner_Spinner__H9do4","brand":"spinner_brand__7jHhk"};